import { useEffect, useMemo, useState } from 'react';

import { useMemberId } from '@trello/authentication';
import { useOneTimeMessagesDismissed } from '@trello/business-logic-react/member';
import { useGetExperimentValue } from '@trello/feature-gate-client';
import { useSplitScreenSharedState } from '@trello/split-screen';

import { useCachedMemberEnterpriseData } from 'app/src/components/TrelloOnline/useCachedMemberEnterpriseData';

export const PLANNER_DISCOVERY_SPOTLIGHT_MESSAGE_ID =
  'planner-discovery-spotlight';

export const useIsEligibleForPlannerDiscoverySpotlight = () => {
  const memberId = useMemberId();
  const { inRealEnterprise } = useCachedMemberEnterpriseData(memberId);

  const { isOneTimeMessageDismissed } = useOneTimeMessagesDismissed();
  const { panels } = useSplitScreenSharedState();

  const [fireExposureEvent, setFireExposureEvent] = useState(false);
  const { cohort: plannerDiscoverySpotlightCohort } = useGetExperimentValue({
    experimentName: 'ghost_planner_discovery',
    parameter: 'cohort',
    fireExposureEvent,
  });

  /**
   * Eligibility Criteria:
   * - User is not in a real enterprise
   * - User has not dismissed the one-time message
   * - User has not already seen the spotlight
   * - Does not have planner open
   * - TODO: Add checks for traits
   */
  const satisfiesEligibilityCriteria = useMemo(
    () =>
      !inRealEnterprise &&
      !isOneTimeMessageDismissed(PLANNER_DISCOVERY_SPOTLIGHT_MESSAGE_ID) &&
      !panels.planner,
    [inRealEnterprise, isOneTimeMessageDismissed, panels],
  );

  useEffect(() => {
    if (satisfiesEligibilityCriteria && !fireExposureEvent) {
      setFireExposureEvent(true);
    }
  }, [satisfiesEligibilityCriteria, fireExposureEvent]);

  return {
    isEligible:
      satisfiesEligibilityCriteria &&
      plannerDiscoverySpotlightCohort === 'experiment',
  };
};
